<template>
  <div class="count-down">
    <div class="count-down__separator"/>
    <span class="count-down__title">
      Compte à rebours avant la <span style="color:#FABC2A">bêta</span>
    </span>
    <div class="count-down__list">
      <div
        v-for="(item, index) in countDown"
        :key="index"
        class="count-down__item"
      >
        <span>{{ item.value }}</span>
        <span class="count-down__item--label">{{ item.label }}</span>
      </div>
    </div>
    <div class="count-down__separator down"/>
  </div>
</template>

<script>
export default {
  name: 'CountDownToBeta',
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  computed: {
    countDown() {
      return [
        { value: this.days, label: 'jours' },
        { value: this.hours, label: 'heures' },
        { value: this.minutes, label: 'minutes' },
        { value: this.seconds, label: 'secondes' },
      ];
    }
  },
  created() {
    this.countDownToBeta();
  },
  methods: {
    countDownToBeta() {
      const countDownDate = new Date('2024/07/31').getTime();
      const x = setInterval(() => {
        const now = new Date().getTime();
        const distance = countDownDate - now;
        this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
        if (distance < 0) {
          clearInterval(x);
        }
      }, 1000);
    }
  },
}
</script>

<style lang="scss" scoped>
.count-down {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: black;
  padding-bottom: 25px;

  &__separator {
    width: 150px;
    height: 0.5px;
    background-color: #FABC2A;
    margin-bottom: 60px;
  }

  &__title {
    font-size: 35px;
    font-weight: 600;
    color: white;
    margin-bottom: 20px;
    padding: 0 50px;

    @media (max-width: 650px) {
      padding: 0 30px;
    }
  }

  &__list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 15px;
    font-size: 30px;
    font-weight: 400;
    color: white;

    &--label {
      font-size: 25px;
    }

    & > span {
      @media (max-width: 650px) {
        font-size: 20px;
      }
    }
  }
}

.down {
  margin-top: 60px;
  margin-bottom: 0;
}
</style>